import './DashboardPage.css';

import React, { Component } from 'react';

import ManagerContext from '../../context/ManagerContext';
import { UtilsService } from '../../services/UtilsService';

import { ActiveJobs } from '../../components/ActiveJobs';
import { ActiveRoutes } from '../../components/ActiveRoutes';
import { MapPane } from '../../components/MapPane';
import { TogglePanel } from '../../components/TogglePanel';



export class DashboardPage extends Component {

    utilsService = new UtilsService();
    static displayName = DashboardPage.name;
    mapPaneRef;
    

    recenterMap(lat, lng) {
        this.mapPaneRef.centerMapByCoordinates(lat, lng);
    }


    recenterMapByDriverNumber(driverNumber) {
        this.mapPaneRef.centerMapByDriverNumber(driverNumber);
    }


    /**
     * Render ActiveRoutes if the logged in account is Sigma related.
     * Else we render ActiveJobs
     */
    renderActiveJobs() {
        if(this.utilsService?.isClientCodeSigmaRelated(this.context?.User?.clientCode)) {
            return <ActiveRoutes activeRouteSelected={(activeRoute) => this.recenterMapByDriverNumber(activeRoute.driver)}></ActiveRoutes>
        } else {
            return <ActiveJobs jobSelected={(job) => this.recenterMap(job?.driverDetail?.latitude, job?.driverDetail?.longitude)}></ActiveJobs>
        }
    }
    
    
    render() {
        let context = this.context;

        if (context.IsLoggedIn) {
            return (
                <div className="dashboard-page flex flex-column gap-5 xl:flex-row xl:gap-2">
                    <div className="active-jobs-container w-full xl:w-6">
                        {this.renderActiveJobs()}
                    </div>

                    <div className="flex flex-column w-full xl:w-6">
                        <div className="map-container">
                            <MapPane ref={(e) => this.mapPaneRef = e}></MapPane>
                        </div>

                        <TogglePanel></TogglePanel>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="dashboard-page">
                    Please ensure that you are logged in
                </div>
            );
        }
  }
}

DashboardPage.contextType = ManagerContext;
